function changeinput(text) {
  var qty = 1;
  var additinoalqty = 1;
  if (text.includes("2")) {
    document.querySelector(".custom_quantity").value = 2;
    qty = 2;
  } else {
    document.querySelector(".custom_quantity").value = 1;
  }

  if (text.includes("Free")) {
    additinoalqty = 2;
  } else {
    additinoalqty = 1;
  }

  var price = document
    .querySelector(".product__info-container .price-item--sale")
    .getAttribute("data-price");
  var compareprice = document
    .querySelector(".product__info-container .price-item--regular")
    .getAttribute("data-price");
  var sign = "CAD";
  if (price.includes("USD") || compareprice.includes("USD")) {
    sign = "USD";
  }

  var updatedprice =
    "$" +
    parseFloat(
      qty * parseFloat(price.replace("$", "").replace(sign, ""))
    ).toFixed(2) +
    " " +
    sign;
  var updatedCompareprice =
    "$" +
    parseFloat(
      qty *
      additinoalqty *
      parseFloat(compareprice.replace("$", "").replace(sign, ""))
    ).toFixed(2) +
    " " +
    sign;

  document.querySelector(
    ".product__info-container .price-item--sale"
  ).textContent = updatedprice;
  document
    .querySelectorAll(".product__info-container .price-item--regular")
    .forEach(function (regular) {
      regular.textContent = updatedCompareprice;
    });

  if (updatedCompareprice == updatedprice) {
    document
      .querySelectorAll(".product__info-container .price-item--regular")
      .forEach(function (regular) {
        regular.style.opacity = "0";
      });
  } else {
    document
      .querySelectorAll(".product__info-container .price-item--regular")
      .forEach(function (regular) {
        regular.style.opacity = "1";
      });
  }
}

if (document.querySelectorAll(".CustomQuantity").length) {
  document.querySelectorAll(".CustomQuantity")[0].click();
}

function closeImgTextPopup() {
  document.querySelector(".imageWithTextPopup").classList.remove("open");
}

function openImgTextPopup() {
  document.querySelector(".imageWithTextPopup").classList.add("open");
}

function buttonImgTextpopup(btn) {
  // btn.closest(".shopify-section").querySelector(".image-with-text .button").click();
  window.location.href =
    "/products/kitty-kurlz-the-interactive-mental-physical-exercise-for-cats";
}

function openCurrency() {
  toggleCurrencyBox()
}

function closeCurrency() {
  toggleCurrencyBox()
}

function toggleCurrencyBox() {
  document
    .querySelector(".customlocalisationpopupdiv")
    .classList.toggle("open");
}

document
  .querySelectorAll(".customlocalisationpopup .indiviusalcountry")
  .forEach(function (option) {
    option.addEventListener("click", function () {
      var code = this.getAttribute("data-code");
      document.querySelector(`#HeaderCountryForm .disclosure__link[data-value="${code}"]`).click();
    });
  });

function openLanguage() {
  document
    .querySelector(".customlocalisationpopupdiv_language")
    .classList.toggle("open");
}

function closeLanguage() {
  document
    .querySelector(".customlocalisationpopupdiv_language")
    .classList.remove("open");
}

document
  .querySelectorAll(".customlocalisationpopup .individuallanguage")
  .forEach(function (option) {
    option.addEventListener("click", function () {
      const code = this.getAttribute("data-language-code");
      // Find the form link with matching language code and click it
      const languageLink = document.querySelector(`#HeaderLanguageForm .disclosure__link[data-value="${code}"]`);
      if (languageLink) {
        languageLink.click();
      } else {
        // Redirect to the appropriate localized URL if the form isn't found
        let currentPath = window.location.pathname;
        // Remove existing language prefix if present
        const locales = ["en", "es", "fr", "de"]; // Add all your available languages
        for (const locale of locales) {
          if (currentPath.startsWith(`/${locale}/`)) {
            currentPath = currentPath.substring(locale.length + 2);
            break;
          } else if (currentPath === `/${locale}`) {
            currentPath = "/";
            break;
          }
        }

        // Add new language prefix (unless it's the default locale)
        const defaultLocale = "en"; // Replace with your default locale
        const newPath = code === defaultLocale ? currentPath : `/${code}${currentPath}`;
        window.location.href = window.location.origin + newPath;
      }
    });
  });

// const languageElement = document.querySelector('.customlocalisation[onClick*="openLanguage()"]');
// if(languageElement) {
//   document.querySelector('.sticky-curency-language-switcher').appendChild(languageElement.cloneNode(true));
//   document.querySelector('.sticky-curency-language-switcher .customlocalisation').classList.remove('small-hide');
//   document.querySelector('.sticky-curency-language-switcher .customlocalisation').classList.remove('medium-hide');
// }


document.querySelectorAll(".productreviews .button").forEach(function (button) {
  button.addEventListener("click", function (e) {
    e.preventDefault();
    var btn = this;
    var allreviews =
      this.closest(".productreviews").querySelectorAll(".hide-reviews");
    var remaingreviews = allreviews.length;
    var loop = 0;

    allreviews.forEach(function (review) {
      if (loop < 7) {
        review.classList.remove("hide-reviews");
        loop++;
      }
    });

    if (remaingreviews < 7) {
      btn.style.display = "none";
    }
  });
});

document.querySelectorAll(".thumbnail-list__item").forEach(function (btn) {
  btn.addEventListener("click", function () {
    if (document.querySelector(".custom-video video")) {
      document.querySelector(".custom-video video").play();
    }
  });
});

function play_video(video) {
  video.parentElement.querySelector("video").play();
}
var video = document.querySelector(".collapsible-content__media video");
const progress = document.getElementById("progress");
const timer = document.getElementById("timer");
var button = document.getElementById("play");
var muted = document.getElementById("mute");

function progressLoop() {
  setInterval(function () {
    progress.value = Math.round((video.currentTime / video.duration) * 100);
    timer.innerHTML = Math.round(video.currentTime) + " seconds";
  });
}

function playPause() {
  if (video.paused) {
    video.play();
    button.innerHTML = "&#10073;&#10073;";
  } else {
    video.pause();
    button.innerHTML = "►";
  }
}

function mute() {
  if (muted.classList.contains("active")) {
    video.muted = false;
    muted.classList.remove("active");
  } else {
    muted.classList.add("active");
    video.muted = true;
  }
}

if (button) button.addEventListener("click", playPause);
if (video) video.addEventListener("play", progressLoop);
if (muted) muted.addEventListener("click", mute);

function SetVolume(val) {
  var player = video;
  console.log("Before: " + player.volume);
  player.volume = val / 100;
  console.log("After: " + player.volume);
}

function extractCurrencyCode(value) {
  // Use a regular expression to match the currency code
  const match = value.match(/\b([a-zA-Z]{3})\b/);

  // Return the currency code if found, or null if not found
  return match ? match[1].toUpperCase() : null;
}

document.addEventListener("DOMContentLoaded", (event) => {

  const comparePriceElement = document.querySelector('.price-item.price-item--compare');
  var comparePriceValue = comparePriceElement.getAttribute('data-price');


  let qtyInput = document.querySelector(
    'form[action="/cart/add"] input[name="quantity"]'
  );
  let qtyInput2 = document.querySelector(
    '.product-form__quantity input[name="quantity"]'
  );
  if (document.querySelector('input[name="properties[Quantity]"]')) {
    const radios = document.querySelectorAll(
      'input[name="properties[Quantity]"]'
    );
    radios.forEach((radio) => {
      radio.addEventListener("change", function () {
        // Get the selected radio button's value
        let qty = this.value;


        qtyInput2.value = qty;

        const currencyCode = extractCurrencyCode(
          document.querySelector(".product .price-item--sale").textContent
        );
        const productContainer = this.closest(".product");


        const Price = parseFloat(item.Price.replace(/[$,]/g, "")) * qty;

        priceValueTimesQty = parseFloat(comparePriceValue.replace(/[$,]/g, "")) * qty;
        var CompareAtPrice = priceValueTimesQty


        if (productContainer.querySelector(".product .price-item--sale")) {
          productContainer
            .querySelectorAll(".product .price-item--sale")
            .forEach(
              (sale) => (sale.textContent = "$" + Price + " " + currencyCode)
            );
        }
        if (productContainer.querySelector(".product .price-item--regular")) {
          productContainer
            .querySelectorAll(".product .price-item--regular")
            .forEach(
              (regular) =>
              (regular.textContent =
                "$" + CompareAtPrice + " " + currencyCode)
            );
        }
      });
    });
  }

  // if (qtyInput) {
  //   qtyInput.addEventListener('change', function(e){
  //     let qty = qtyInput.value;
  //     console.log('qty', qty);
  //     if(document.querySelector('.CustomQuantity')) {
  //       document.querySelector('.CustomQuantity').value = qty;
  //       document.querySelector('.custom_quantity').value = qty;
  //     }
  //   });
  // }

  function updateShippingBar(cart) {
    const totalPrice = parseInt(cart.total_price);
    const shippingPrice = parseInt(document.querySelector('#CartDrawer').getAttribute('data-shipping-price'));
    const shippingText = document.querySelector('#CartDrawer').getAttribute('data-shipping-text');
    const shippingFullText = document.querySelector('#CartDrawer').getAttribute('data-shipping-reached-text');
    if (totalPrice < shippingPrice) {
      let diffPrice = parseFloat((shippingPrice - totalPrice) / 100);
      document.querySelector('.cart-free-shipping--label').textContent = shippingText.replace('(price)', '$' + diffPrice.toFixed(2));
      document.querySelector('.cart-free-shipping-bar').style.width = `${totalPrice * 100 / shippingPrice}%`;
    } else {
      document.querySelector('.cart-free-shipping--label').textContent = shippingFullText;
      document.querySelector('.cart-free-shipping-bar').style.width = '100%';
    }
  }

  function updateCheckoutBtn(cart) {
    const totalPrice = parseInt(cart.total_price) / 100;
    document.querySelector('#CartDrawer-Checkout').textContent = `Checkout $${totalPrice.toFixed(2)}`;
  }

  async function addClimateItem() {
    const data = {
      id: document.querySelector('#CartDrawer').getAttribute('data-climate-id'),
      quantity: 1
    };

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to add item to cart');
      }

      // Fetch the full cart object
      const cartResponse = await fetch('/cart.js');
      if (!cartResponse.ok) {
        const errorData = await cartResponse.json();
        throw new Error(errorData.message || 'Failed to fetch cart');
      }

      const cart = await cartResponse.json();
      console.log('Climate product added');
      document.querySelector('.climate-cta').classList.remove('loading');
      document.querySelector('.climate-cta').classList.add('active');

      if (document.querySelector('.cart-free-shipping')) {
        updateShippingBar(cart);
      }
      updateCheckoutBtn(cart);

    } catch (error) {
      console.error('Error adding item to cart:', error);
    }
  }

  async function removeClimateItem() {
    const data = {
      id: document.querySelector('#CartDrawer').getAttribute('data-climate-id'),
      quantity: 0 // Set quantity to 0 to remove the item
    };

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to remove item from cart');
      }

      const cart = await response.json();
      console.log('Climate product removed');

      document.querySelector('.climate-cta').classList.remove('loading');
      document.querySelector('.climate-cta').classList.remove('active');

      if (document.querySelector('.cart-free-shipping')) {
        updateShippingBar(cart);
      }
      updateCheckoutBtn(cart);
    } catch (error) {
      console.error('Error removing item from cart:', error);
    }
  }


  document.body.addEventListener('click', function (evt) {
    if (document.querySelector('.climate-cta') && document.querySelector('#CartDrawer').getAttribute('data-climate-id')) {
      if (evt.target && (evt.target.matches('.climate-cta') || evt.target.matches('.climate-toggle'))) {
        document.querySelector('.climate-cta').classList.add('loading');
        if (document.querySelector('.climate-cta').classList.contains('active')) {
          if (document.querySelector('.climate-item')) {
            // document.querySelector('.climate-item .cart-remove-button').click();
            removeClimateItem();
          } else {
            removeClimateItem();
          }
        } else {
          addClimateItem();
        }
        evt.preventDefault();
      }
    }
  });


});
